import { tipsConstants } from '../../constants';
import { tipsService } from '../../services';
import { alertActions } from '..';
import { generalErrorHandler, resetAbortController } from '../utils';

export default function loadInfluencerWinRates(region, influencerId) {
  return dispatch => {
    const ac = resetAbortController(
      tipsConstants.LOAD_INFLUENCER_WIN_RATES_REQUEST
    );
    dispatch(request());
    dispatch(alertActions.clear());

    return tipsService
      .loadInfluencerWinRates(ac.signal, region, influencerId)
      .then(
        ({ influencerRanks, influencerTips }) => {
          dispatch(success(influencerRanks, influencerTips));
        },
        generalErrorHandler(dispatch, error =>
          dispatch(failure(error.toString()))
        )
      );
  };

  function request() {
    return { type: tipsConstants.LOAD_INFLUENCER_WIN_RATES_REQUEST };
  }
  function success(influencerRanks, influencerTips) {
    return {
      type: tipsConstants.LOAD_INFLUENCER_WIN_RATES_SUCCESS,
      influencerRanks,
      influencerTips,
    };
  }
  function failure(error) {
    return { type: tipsConstants.LOAD_INFLUENCER_WIN_RATES_FAILURE, error };
  }
}
